import { render, staticRenderFns } from "./UpdateOtherLoanStatusModal.vue?vue&type=template&id=0faac323"
import script from "./UpdateOtherLoanStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateOtherLoanStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports